import {
  HeroStandard as ZinniaHeroStandard,
  HeroStandardProps,
} from '@zapier/design-system';
import { innerText } from '../../../utils/innerText';
import {
  CtaGoalType,
  CtaNameType,
  EventName,
  useAvroTracking,
  useTrackEvent,
} from '../../../observability';
import { RichTextHtml } from '../../RichTextHtml/RichTextHtml';
import { RichTextHTMLString } from '../types';

type Props = HeroStandardProps & {
  ctaName: CtaNameType;
  ctaGoal: CtaGoalType;
  ctaDisclaimer: RichTextHTMLString;
};

/**
 * This component has been deprecated.
 * Please use HeroSection instead.
 */
export function HeroStandard(props: Props) {
  const trackEvent = useTrackEvent();
  const { emitCTAClickEvent } = useAvroTracking();

  const handleCtaClick = () => {
    emitCTAClickEvent({
      text: innerText(props.ctaText),
      section: `hero_section_standard`,
      href: props.ctaHref!,
    });
    trackEvent(EventName.CALL_TO_ACTION, {
      path: window.location.pathname,
      from_path: document.referrer,
      cta_name: props.ctaName,
      cta_raw_text: props.ctaText,
      cta_goal: props.ctaGoal,
    });
  };

  return (
    <ZinniaHeroStandard
      {...props}
      ctaDisclaimer={<RichTextHtml html={props.ctaDisclaimer} />}
      maxWidth={1280}
      onCtaClick={handleCtaClick}
    >
      {props.children}
    </ZinniaHeroStandard>
  );
}
